// The DS Table CustomRules recipe's StickyEdgeShadow, copied verbatim.
// border-collapse drops cell box-shadows in Chrome, so a frozen cell hosts a
// gradient strip just outside its edge instead. `side` is which edge of the
// cell the strip sits on: 'left' for a right-pinned column (shadow points left
// into the scrolling content), 'right' for a left-pinned column. The recipe's
// cg- arbitrary classes are storybook JIT output, absent from the vendored
// stylesheet, so they are respelled to the platform's own Tailwind.
export const StickyEdgeShadow = ({
	show,
	side = 'left',
}: {
	show: boolean
	side?: 'left' | 'right'
}) => (
	<span
		aria-hidden
		className={`pointer-events-none absolute inset-y-0 z-[1] w-2 transition-opacity duration-200 motion-reduce:transition-none ${
			side === 'right'
				? 'right-0 translate-x-full bg-gradient-to-r from-[rgba(0,0,0,0.10)] to-[rgba(0,0,0,0)]'
				: 'left-0 -translate-x-full bg-gradient-to-l from-[rgba(0,0,0,0.10)] to-[rgba(0,0,0,0)]'
		} ${show ? 'opacity-100' : 'opacity-0'}`}
	/>
)
